module.exports = __webpack_public_path__ + "static/media/SolutionsHero.0707fd11.png";